module.exports = {"130133100":"赵州镇","130133101":"范庄镇","130133102":"北王里镇","130133103":"新寨店镇","130133104":"韩村镇","130133105":"南柏舍镇","130133106":"沙河店镇","130133107":"王西章镇","130133200":"前大章乡","130133201":"谢庄乡","130133202":"高村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130133.json
// module id = 160
// module chunks = 0